import { VehicleConditions, VehicleTypesT } from "../../utils/GeneralTypes";
import axiosInstance from "../../utils/setupAxios";

export const getWishlistVehicles = async (vehicle: VehicleTypesT) => {
  // return JSON.parse(localStorage.getItem('romotors_wishlist') || "{}");
  return await axiosInstance.get(`wishlist/${vehicle}`);
};

export const getCompareVehicles = () => {
  return JSON.parse(localStorage.getItem("romotors_compare") || "{}");
};

export const updateWishlist = async (vehicle: VehicleTypesT, type: "add" | "delete", id: string) => {
  if (type === "add") return await axiosInstance.post(`wishlist/${vehicle}/add/${id}`);
  else return await axiosInstance.delete(`wishlist/${vehicle}/remove/${id}`);
};

export const updateCompare = (vehicleType: VehicleTypesT, vehicleState: VehicleConditions, id: string) => {
  let currentCompare = getCompareVehicles();
  let compareFlag = false;
  if (currentCompare?.[vehicleType]?.[vehicleState]?.includes(id)) {
    currentCompare[vehicleType][vehicleState] = currentCompare[vehicleType][vehicleState].filter(
      (el: string) => el !== id,
    );
  } else {
    if (!currentCompare?.[vehicleType]) currentCompare[vehicleType] = {};
    if (!currentCompare[vehicleType]?.[vehicleState]) currentCompare[vehicleType][vehicleState] = [];
    if (currentCompare[vehicleType][vehicleState].length === 3) compareFlag = true;
    else currentCompare[vehicleType][vehicleState].push(id);
  }
  localStorage.setItem("romotors_compare", JSON.stringify(currentCompare));
  return compareFlag;
};
